<script>
  export default {
    name: 'CommonMode',
    props: {
      type: {
        type: String,
        required: true,
        default: 'spreadsheet',
      },
      integration: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      selectAll: false,
      selectedFields: [],
      sendExisting: true,
      displayAnswer: 'answer_values',
      fields: ['Submission ID', 'Submission Date'],
      loading: false
    }),
    computed: {
      selectedAllItems() {
        return this.selectedFields.length === this.fields.length
      },
      selectedSomeItems() {
        return this.selectedFields.length > 0 && !this.selectedAllItems
      },
      icon() {
        if (this.selectedAllItems) return 'mdi-close-box'
        if (this.selectedSomeItems) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
    },
    mounted() {
      if (this.integration.itemId) {
        this.selectedFields = this.integration.selectedFields || []
        this.sendExisting = this.integration.sendExisting
        this.displayAnswer = this.integration.displayAnswers
          ? 'answer_values'
          : 'answer_codes'
      }
    },
    methods: {
      toggle() {
        this.$nextTick(() => {
          if (this.selectedAllItems) {
            this.selectedFields = []
          } else {
            this.selectedFields = this.fields.slice()
          }
        })
      },
      saveInfo() {
        this.loading = true;
        this.$emit('save-info', {
          selectedFields: this.selectedFields,
          sendExisting: this.sendExisting,
          displayAnswer: this.displayAnswer,
        })
      },
    },
  }
</script>

<template>
  <div>
    <h3 class="mt-3 mb-5 form-integrarion-text">
      Choose fields to send to {{ integration.title }}
    </h3>
    <v-select
      v-model="selectedFields"
      :items="fields"
      label="Select fields"
      outlined
      dense
      multiple
    >
      <template #prepend-item>
        <v-list-item
          ripple
          @mousedown.prevent
          @click="toggle"
        >
          <v-list-item-action>
            <v-icon :color="selectedFields.length > 0 ? 'indigo darken-4' : ''">
              {{ icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Select All</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-select>
    <h3 class="mt-3 form-integrarion-text">Row Data Options</h3>
    <v-radio-group
      v-model="displayAnswer"
      class="mb-5"
    >
      <v-radio
        label="Display Answer Values"
        value="answer_values"
        class="mb-3"
      ></v-radio>
      <v-radio
        label="Display Answer Codes/Index"
        value="answer_codes"
      ></v-radio>
    </v-radio-group>
    <div class="group-control__wrapper">
      <f-switch
        v-model="sendExisting"
        class="mr-2"
      />
      Export Existing Data
    </div>
    <v-row justify="start">
      <v-btn
        height="32"
        class="mt-6 rounded-pill font-weight-medium save-btn"
        color="gray_700"
        outlined
        text
        :loading="loading"
        :disabled="loading"
        @click="saveInfo"
      >
        Save
      </v-btn>
    </v-row>
  </div>
</template>

<style lang="scss">
  .save-btn {
    width: 120px !important;
    height: 32px !important;
  }
  .form-integration-title {
    color: var(--v-grey_3-base);
    font-size: 12px;
    font-weight: 400;
  }

  .group-control__wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }
  .form-integrarion-text {
    color: var(--v-gray_700-base);
    font-size: 16px;
    font-weight: 500;
  }
</style>
